$(function () {
  const sliderEl = $('.highlighted-items-slider__slides');

  // Init callback
  sliderEl.on('init', function (ev, slider) {
    sliderEl.addClass('-init').on('click', function () {
      slider.pause();
    });

    $('.slick-arrow').html('<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="m517.85-480-184-184L376-706.15 602.15-480 376-253.85 333.85-296l184-184Z" /></svg>');
  });

  sliderEl.on('swipe', function (ev, slider) {
    slider.pause();
  });

  // Hero slider
  sliderEl.slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
  });
});
